export class QueryExecutionV2 {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "QueryExecutionStatus",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "QueryEngine",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "errorMessage",
            "baseName": "errorMessage",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return QueryExecutionV2.attributeTypeMap;
    }
    constructor() {
    }
}
